import { useQuery } from '@tanstack/react-query';
import type { AgentApiCustomFieldsIndex } from '@/types/serializers';

export interface CustomField {
  id: number;
  name: string;
  unitName: string | null;
  orderNumber: number;
  fieldType: string;
}

export default function useCustomFields() {
  return useQuery({
    queryKey: ['/agent/api/candidate_profiles/custom_fields'],
    queryFn: async () => {
      const response = await fetch('/agent/api/candidate_profiles/custom_fields.json');
      const data: AgentApiCustomFieldsIndex = await response.json();
      return {
        customFields: data.records.map((cf) => ({
          id: cf.id,
          name: cf.name,
          unitName: cf.unit_name,
          orderNumber: cf.order_number,
          fieldType: cf.field_type,
        })) as CustomField[],
      };
    },
  });
}
